import { prepareNextJsProps } from '@/modules/_core/utils/nextjs.utils';
import {
	CommunityEventCalendar,
	EmbedEventCalendarPageProps,
} from '@/modules/embed/pages/embed-event-calendar/embed-event-calendar.page';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/modules/_core/constants';
import { eventsService, usersService } from '@/modules/_core/services';

export const getServerSideProps = async context => {
	const { res } = context;

	res.setHeader('Cache-Control', `public, max-age=${10}, s-maxage=${10}, stale-while-revalidate=59`);

	const params = context.params as { entityAlias: string };

	const communityUsername = params.entityAlias;

	if (!communityUsername) {
		return {
			notFound: true,
		};
	}

	const queryClient = new QueryClient();

	await queryClient.prefetchQuery(queryKeys.hostRelated(communityUsername, 'get-id'), async () =>
		usersService.findPublicIdByUsername(communityUsername)
	);

	const hostId = queryClient.getQueryData<string>(queryKeys.hostRelated(communityUsername, 'get-id'));

	if (!hostId) {
		return {
			notFound: true,
		};
	}

	await queryClient.prefetchQuery(queryKeys.hostRelated(hostId), async () =>
		usersService.getUserByIdPublic(hostId)
	);

	const props = context.query as EmbedEventCalendarPageProps;

	return {
		props: prepareNextJsProps({
			...props,
			dehydratedState: dehydrate(queryClient),
		}),
	};
};

export default CommunityEventCalendar;
